import { IconFile } from "@tabler/icons-react"
import { type FC, useState } from "react"

import { CheckmarkIcon, DeleteIcon } from "~/components/Icon"

const Preview: FC<{ imageFilePath: string; onDelete?(): Promise<void> | void }> = ({ imageFilePath, onDelete }) => {
	const [isDeleting, setDeleting] = useState(false)

	return (
		<div className="border-primary flex items-start gap-4 rounded-lg border bg-white p-4">
			<div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border-4 border-[#f6f3ff] bg-[#edebf3]">
				<IconFile className="text-primary size-4" />
			</div>
			<div className="flex-1">
				<img alt="Image preview" src={imageFilePath} className="h-42 w-full object-contain object-left" />
			</div>
			{onDelete && (
				<button
					type="button"
					className="cursor-pointer rounded-full bg-black/30 p-2 transition-all duration-100 hover:bg-black/50"
					onClick={async () => {
						setDeleting(true)
						try {
							await onDelete()
						} catch (error) {
							console.error(error)
							setDeleting(false)
							return
						}
						setDeleting(false)
					}}
					disabled={isDeleting}
				>
					<DeleteIcon className="text-danger size-4" />
				</button>
			)}
			<div className="bg-primary rounded-full p-1">
				<CheckmarkIcon className="size-2 text-white" />
			</div>
		</div>
	)
}

export default Preview
